import { userLicenseStateApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const USER_LICENSE_ACTION_TYPE = createNamedActions('userLicense', {
  GET_USER_LICENSES: 'GET_USER_LICENSES',
  ADD_USER_LICENSE: 'ADD_USER_LICENSE',
  EDIT_USER_LICENSE: 'EDIT_USER_LICENSE',
  DELETE_USER_LICENSE: 'DELETE_USER_LICENSE',
});

const license = new schema.Entity('data', {}, { idAttribute: ({ id }) => id });

export const getLicensesAction = catchAsyncActionError(
  ({ companyId, userId }) =>
    async dispatch => {
      const { data } = await userLicenseStateApi.getLicenseStates({ userId, companyId });

      return dispatch({
        type: USER_LICENSE_ACTION_TYPE.GET_USER_LICENSES,
        payload: normalize(data, [license]).entities.data,
      });
    },
);

export const createLicenseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userLicenseStateApi.createLicenseState(params);

  return dispatch({
    type: USER_LICENSE_ACTION_TYPE.ADD_USER_LICENSE,
    payload: data,
  });
});

export const editLicenseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userLicenseStateApi.editLicenseState(params);

  return dispatch({
    type: USER_LICENSE_ACTION_TYPE.EDIT_USER_LICENSE,
    payload: data,
  });
});

export const deleteLicenseAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await userLicenseStateApi.deleteLicenseState(params);

  return dispatch({
    type: USER_LICENSE_ACTION_TYPE.DELETE_USER_LICENSE,
    payload: data,
    meta: params,
  });
});
